import { IMainHeader } from "@/domain/main-header/entity/MainHeader.interface";
import { MainHeaderApplicationDataProvider } from "@/domain/main-header/application/MainHeaderApplicationData.provider";
import { ScriptSelector } from "@/domain/main-header/entity/ScriptSelector.enum";
import { Profile } from "@/domain/main-header/entity/Profile.interface";
import { ProfileCategory } from "@/domain/main-header/entity/ProfileCategory.interface";
import { MainHeaderTitle } from "@/domain/main-header/entity/MainHeaderTitle.enum";
import { ProfileDTO } from "@/domain/main-header/dto";

export class ProfileConfigurationProvider {
    public static provideTo(mainHeaderApplicationData: Partial<IMainHeader>): Partial<IMainHeader> {
        const profileData = MainHeaderApplicationDataProvider.hasProvidedDataFor(ScriptSelector.PROFILE) ?
            MainHeaderApplicationDataProvider.parseProvidedData<ProfileDTO>(ScriptSelector.PROFILE)
            : null;

        if (!profileData) {
            return mainHeaderApplicationData;
        }

        mainHeaderApplicationData.profile = this.normalizeProfileData(profileData);

        return mainHeaderApplicationData;
    }

    private static normalizeProfileCategoriesData(data: ProfileCategory[]): ProfileCategory[] {
        const profileCategories = data.map((category) => {
            return {
                id: category.id ?? '',
                name: category.name ?? '',
                label: category.label ?? '',
                title: category.title ?? '',
                url: category.url ?? '',
                action: category.action ?? undefined,
                auth: category.auth ?? false,
                showChildren: category.showChildren ?? false,
                subCategories: category.subCategories ?? [],
                showCartStatus: category.showCartStatus ?? false,
            }
        });

        return profileCategories;
    }

    private static normalizeProfileData(data: ProfileDTO): Profile {
        return {
            sectionName: MainHeaderTitle.PROFILE,
            name: data.name ?? '',
            title: data.title ?? '',
            categories: this.normalizeProfileCategoriesData(data.children ?? []),
            loginUrl: data.loginUrl ?? '',
            logoutUrl: data.logoutUrl ?? '',
            showChildren: data.showChildren ?? false,
            url: data.url ?? '',
        }
    }
}